/**
 * Dependencies.
 */
import Qrcode from '@chenfengyuan/vue-qrcode';
import { Component, Mixins } from 'vue-property-decorator';

import StatusCard from '@/modules/tracking/components/status/card/status-card.component.vue';
import TimelineMixin from '@/modules/tracking/mixins/timeline.mixin';
import TrackingMixin from '@/modules/tracking/mixins/tracking.mixin';
import { trackingStore } from '@/modules/tracking/store';
import Error from '@/ui/components/error.component.vue';
import NotifyClientRequest from '@/ui/components/notify/client-request.component.vue';
import Timeline from '@/ui/components/timeline/timeline.component.vue';

/**
 * Component.
 */
@Component({
  components: {
    Error,
    NotifyClientRequest,
    Qrcode,
    StatusCard,
    Timeline
  },
  name: 'pick-up-code-scene'
})
export default class extends Mixins(TrackingMixin, TimelineMixin) {
  /**
   * Getter `pin`.
   */
  get pin() {
    return trackingStore.servicePointOrderPin || '';
  }

  /**
   * Lifecycle mounted hook.
   */
  async mounted() {
    this.$on('trackingDataUpdated', () => {
      const isValid = this.handleIsValidToBeOnScene();

      if (!isValid) {
        this.handleForceTrackingScene();
      }
    });

    await this.handleInitializeMixin();

    const isValid = this.handleIsValidToBeOnScene();

    if (!isValid) {
      this.handleForceTrackingScene();
    }
  }

  /**
   * Handle is valid to be on scene.
   */
  handleIsValidToBeOnScene() {
    const [currentTracking] = trackingStore.tracking || [];
    const { status: { code = null } = {} } = currentTracking || {};
    const { IN_SERVICE_POINT } = this.trackingStatus;

    return code === IN_SERVICE_POINT;
  }

  /**
   * Handle go back.
   */
  handleGoBack() {
    this.$router.push({
      name: 'Tracking',
      params: {
        key: this.key
      }
    });
  }
}
